import React from 'react';
import { motion } from 'framer-motion';
import FormRegistration from '../components/FormRegistration';
import '../assets/css/PreRegistration.css';

// --- Framer Motion Variants ---
const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const heroContentVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      staggerChildren: 0.2,
    },
  },
};

const heroSubtitles = [
  "Inscreva o seu talento.",
  "Faça parte da nossa família!",
  "Educação que transforma."
];

const AnimatedSubtitle = () => {
  const [index, setIndex] = React.useState(0);
  React.useEffect(() => {
    const timeout = setTimeout(() => setIndex((i) => (i + 1) % heroSubtitles.length), 2600);
    return () => clearTimeout(timeout);
  }, [index]);
  return (
    <motion.h3
      className="pr-hero-subtitle"
      key={index}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.7 }}
    >
      {heroSubtitles[index]}
    </motion.h3>
  );
};

const PreRegistration = () => {
  return (
    <div className="pre-registration-page">
      {/* HERO PRIMEIRO COMPONENTE */}
      <motion.section
        className="pr-hero-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <div className="pr-hero-background-layer"></div>
        <div className="pr-hero-overlay"></div>
        {/* Círculos decorativos inspirados na Home */}
        <div className="pr-hero-decoration-circles">
          <div className="pr-hero-circle pr-hero-circle-1-alt"></div>
          <div className="pr-hero-circle pr-hero-circle-2-alt"></div>
          <div className="pr-hero-circle pr-hero-circle-3-alt"></div>
        </div>
        <div className="pr-hero-row">
          <div className="pr-hero-col pr-hero-content">
            <motion.div
              className="pr-hero-content-inner"
              initial="hidden"
              animate="visible"
              variants={heroContentVariants}
            >
              <motion.h1
                className="pr-hero-title"
                variants={heroContentVariants}
              >
                Pré-inscrições
              </motion.h1>
              <AnimatedSubtitle />
              <motion.p
                className="pr-hero-description"
                variants={heroContentVariants}
              >
                Garanta a vaga do seu filho(a) no Talatona Kids! Preencha o formulário e nossa equipa entrará em contacto.
              </motion.p>
            </motion.div>
          </div>
          <div className="pr-hero-col pr-hero-checklist">
            <div className="pr-checklist-card-decoration">
              <div className="pr-checklist-circle pr-checklist-circle-1"></div>
              <div className="pr-checklist-circle pr-checklist-circle-2"></div>
              <div className="pr-checklist-floating-shape pr-checklist-shape-star">
                <i className="bi bi-star-fill"></i>
              </div>
            </div>
  
          </div>
        </div>
      </motion.section>
      
      {/* SEÇÃO DO FORMULÁRIO */}
      <section className="pr-form-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <motion.div
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={sectionVariants}
              >
                <FormRegistration />
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PreRegistration;